var _defs, _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappyFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 395.22,
    y1: 292.79,
    x2: 1690.25,
    y2: 1751.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffca4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7ae30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 438.45,
    y1: 406.02,
    x2: 847.95,
    y2: 822.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffca4f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1022.7,
    y1: 1128.93,
    x2: 1022.7,
    y2: 1627.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7ae30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffca4f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1030.29,
    y1: 1007.07,
    x2: 1623.58,
    y2: 1590.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffca4f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4901f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 652.65,
    y1: 611.49,
    x2: 819.39,
    y2: 815.28,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1229.72,
    y1: 614.84,
    x2: 1396.45,
    y2: 810.2,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 675.82,
    y1: 639.81,
    x2: 794.98,
    y2: 785.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f4c56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27333e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1253.07,
    y1: 642.2,
    x2: 1372.22,
    y2: 781.81,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1022.7,
    y1: 1166.47,
    x2: 1022.7,
    y2: 1587.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eaecf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cdd3f1"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1022.7,1846.88c-467.21,0-847.3-380.1-847.3-847.3S555.49,152.28,1022.7,152.28s847.3,380.1,847.3,847.3-380.1,847.3-847.3,847.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M637.56,1384.72c0-424.72,345.55-770.28,770.28-770.28,112.82,0,219.73,24.98,316.38,68.76-121.01-267.21-389.62-453.89-701.52-453.89-424.72,0-770.28,345.55-770.28,770.28,0,311.9,186.69,580.51,453.89,701.52-43.77-96.66-68.76-203.56-68.76-316.38Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1022.7,1615.8c-297.32,0-539.19-205.58-539.19-458.27l.26-5.3v-38.51l38.48,1.41h1039.65l-.23,38.51c.11.34.23,2.11.23,3.89,0,252.69-241.88,458.27-539.19,458.27Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M423.84,1598.43c153.43,153.43,365.25,248.45,598.85,248.45,467.21,0,847.3-380.1,847.3-847.3,0-233.6-95.02-445.43-248.45-598.85L423.84,1598.43Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M733.84,845.53c-74.32,0-134.8-60.48-134.8-134.8s60.48-134.8,134.8-134.8,134.8,60.48,134.8,134.8-60.48,134.8-134.8,134.8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1311.55,845.53c-74.32,0-134.8-60.48-134.8-134.8s60.48-134.8,134.8-134.8,134.8,60.48,134.8,134.8-60.48,134.8-134.8,134.8Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 733.84,
    cy: 710.73,
    r: 96.28
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 1311.55,
    cy: 710.73,
    r: 96.28
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M522.25,1153.64c-.01,1.31-.23,2.58-.23,3.89,0,231.83,224.16,419.76,500.68,419.76s500.68-187.94,500.68-419.76c0-1.31-.22-2.58-.23-3.89h-1000.89Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyFace);
export default __webpack_public_path__ + "static/media/Happy Face.718d4534fc4a77d8bb768f350239d6b8.svg";
export { ForwardRef as ReactComponent };